/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

export enum UserDataKey {
  /**
   * Unique user identifier of the user
   */
  USER_ID = 'user_id',
  /**
   * User type according to their subscription state
   */
  USER_TYPE = 'user_type',
  /**
   * Unique subscription identifier for the user's subscription
   */
  USER_SUBSCRIPTION_ID = 'user_subscription_id',
  /**
   * Status of the user's subscription state
   */
  USER_SUBSCRIPTION_STATUS = 'user_subscription_status',
  /**
   * Subscription plan type name
   */
  SUBSCRIPTION_PLAN = 'subscription_plan',
  /**
   * Subscription plan type id
   */
  SUBSCRIPTION_PLAN_ID = 'subscription_plan_id',
  /**
   * Unique identifier for the user's profile
   */
  PROFILE_ID = 'profile_id',
  /**
   * User's profile type
   */
  PROFILE_TYPE = 'profile_type',
  /**
   * Base subscription type for the user, e.g., basic, premium, etc.
   */
  BASE_SUBSCRIPTION = 'base_subscription',
  /**
   * Indicates whether the user was authenticated using silent login
   * (i.e., without explicit user interaction).
   */
  SILENT_LOGIN = 'silent_login',
}
